<!-- Une carte par famille : ses cultures se déplient dans la même carte, alignées sur elle. -->
<div class="rounded-card border border-vw-line bg-vw-surface px-2">
  <vw-calendar-hierarchy-card-item [cultivation]="hierarchy.cultivations[0]"
    [name]="isGroup ? hierarchy.name.toString() : hierarchy.cultivations[0].name.toString()"
    [type]="isGroup ? 'hierarchy' : 'cultivation'" [periods]="hierarchy.periods"
    [badge]="hierarchyBadge" [isOpen]="isOpen" (clickItem)="onParentClick()"></vw-calendar-hierarchy-card-item>
  @if (isGroup) {
    <div class="cal-family grid transition-[grid-template-rows] duration-300 ease-out"
      [style.grid-template-rows]="isOpen ? '1fr' : '0fr'" [attr.inert]="isOpen ? null : ''">
      <div class="min-h-0 overflow-hidden">
        @for (cultivation of hierarchy.cultivations; track cultivation.uid) {
          <div class="border-t border-vw-line">
            <vw-calendar-hierarchy-card-item [cultivation]="cultivation" [type]="'cultivation'" [periods]="cultivation.periods"
              [badge]="badgeOf(cultivation.uid)" (clickItem)="onChildClick(cultivation)"></vw-calendar-hierarchy-card-item>
          </div>
        }
      </div>
    </div>
  }
</div>
